<template>
  <div>
    <div>
      <columns>
        <column>
          <text-input 
            required
            :error="$root.errorBag.description" 
            v-model="vulnerability.description" 
            placeholder="Database User">
            Description
          </text-input>
        </column>
        <column>
          <text-input 
            required
            :error="$root.errorBag.code" 
            v-model="vulnerability.code" 
            placeholder="database_user, laravel_version">
            Code
          </text-input>
        </column>
        <column class="is-narrow">
          <number-input 
            required
            :error="$root.errorBag.cvss" 
            v-model="vulnerability.cvss" 
            :precision="2" 
            :max="10" 
            :min="0">
            Score
          </number-input>
        </column>
        <column>
          <switch-input
            classes="is-large"
            v-model="vulnerability.default_exposure">
            Default Exposure
          </switch-input>
        </column>
      </columns>
      <columns>
        <column>
          <text-area 
            required
            :error="$root.errorBag.description" 
            v-model="vulnerability.description">
            Summary of Vulnerability
          </text-area>
          <text-area 
            :error="$root.errorBag.recommendation" 
            v-model="vulnerability.recommendation">
            Recommendation (optional)
          </text-area>
        </column>
      </columns>
    </div>
    <div>
      <h3 class="is-size-4">Vectors <small class="has-text-grey">(optional)</small></h3>
      <p class="mb-1 has-text-grey">Specific attack vectors that we will be searching for. If any of below vectors appear in our findings this vulnerability will be flagged.</p>
      <text-input v-model="vector">
        <template #right>
          <action-button @click="addVector(vector)" class="is-success">
            <icon icon="plus"/>
          </action-button>
        </template>
      </text-input>

      <table class="table is-fullwidth">
        <tbody>
          <tr v-for="(attackVector, index) in vulnerability.vectors" :key="index">
            <td>{{ attackVector }}</td>
            <td class="is-narrow">
              <action-button @click="removeVector(attackVector)" class="is-danger is-small">
                <icon icon="trash"/>
              </action-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <columns>
      <column>
        <submit-button :working="working" @submit="save" left-icon="save" class="is-success is-rounded mt-1">Capture Vulnerability</submit-button>
      </column>
    </columns>
  </div>
</template>
<script>
import { storeVulnerability } from '@/api/super'

export default {
  
  data: () => ({
    working: false,
    vector: '',
    vulnerability: {
      description: '',
      code: '',
      cvss: 0,
      description: '',
      recommendation: '',
      vectors: []
    }
  }),

  methods: {
    save() {
      this.working = true
      storeVulnerability(this.vulnerability, response => {
        this.working = false
        this.$router.push({
          name: 'vulnerabilities'
        })
      }, error => {
        this.working = false
      })
    },
    addVector(vector) {
      if(this.vulnerability.vectors.indexOf(vector) > -1) return
      this.vulnerability.vectors.push(vector)
      this.vector = ''
    },
    removeVector(vector) {
      this.vulnerability.vectors = this.vulnerability.vectors.splice(this.vulnerability.vectors.indexOf(vector), 1)
    }
  }

}
</script>